export class CheckoutScenarioSettings{

    constructor(
        //mostra ou não botão para alternar entre ter ou não planejamento
        public showTogglePlanningButton: boolean = true, 
        //permitir que o gain e stop sejam editados
        public enableGainStopEditing: boolean = true, 
        //Mostrar o checkbox para habilitar/desabilitar day trade
        public enableDayTradeControl: boolean = true, 
        //Mostrar o checkout-observation sobre o day trade
        public showDayTradeInfo: boolean = true,
        //é opção?
        public isOption: boolean = false,
        //é uma compra?
        public purchase: boolean = true,
        //perfil adequado
        public incompatibleProfile: boolean = false,
        //edição
        public editing: boolean = false,
        //já foi executado
        public alreadyExecuted: boolean = false,
        //criando planejamento
        public creatingPlanning: boolean = false,
        //é uma recomendacao
        public isAdvice: boolean = false,
        //ordem ja enviada (pode nao estar executada ainda)
        public alreadySent: boolean = false,

    ){ }


    get confirmButtonLabel():string{
        
        if(this.alreadyExecuted && !this.editing)
            return 'Criar planejamento';
        
        if(this.editing)
            return 'Editar';

        return 'Investir';
    }

    get mobileConfirmButtonLabel():string{

        if(this.alreadyExecuted && !this.editing)
            return 'Criar';
        
        return '';
    }
}